import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import { getAllInvoices } from "../../../actions/invoiceItem";
import { getAllOutlet } from "../../../actions/warehouseAction";
import { getSalesReport, getSalesReportP } from "../../../actions/report";
import RenderTable from "./RenderTable";
import { Divider, Skeleton, Space, Button } from "antd";
import {
  Layout,
  Breadcrumb,
  DatePicker,
  Select,
  AutoComplete,
  Row,
  Col,
} from "antd";
const { RangePicker } = DatePicker;
const { Content } = Layout;
const { Option } = Select;

const Index = ({ getSalesReport, getSalesReportP, Auth, getAllOutlet }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const pageno = useRef(1);
  const page_size = useRef(10);
  const [reload, setreload] = useState(false);
  const [update, setUpdate] = useState(false);
  const [outletlist, setoutletlist] = useState([]);
  const [type, setType] = useState("date");
  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const status = useRef("");
  const location = useRef(Auth.superuser ? "" : Auth.profile.branch.id);

  useEffect(() => {
    const fetchData = async () => {
      const outlets = await getAllOutlet();
      setoutletlist(outlets);
      const result = await getSalesReportP(
        start.current,
        end.current,
        keyward.current,
        "",
        "",
        "",
        status.current,
        "",
        location.current,
        "",
        pageno.current,
        page_size.current
      );
      setData(result);
      setUpdate(true);
      setLoading(false); // Data fetching is complete
    };

    fetchData();
  }, [reload, getAllOutlet, getSalesReportP]);

  const onChange = (event) => {
    if (event.keyCode === 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(!reload);
    }
  };

  const onSearchClick = () => {
    setLoading(true);
    setreload(!reload);
  };

  const rendertable = () => {
    if (loading) {
      return <Skeleton active />;
      return <Skeleton active />;
      return <Skeleton active />;
      return <Skeleton active />;
      return <Skeleton active />;
    }
    return (
      <RenderTable
        List={data}
        pageno={pageno}
        page_size={page_size}
        setreload={setreload}
        reload={reload}
        setUpdate={setUpdate}
      />
    );
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Exchange Panel</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row>
          <Space>
            Keyward :
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "200px" }}
            />
            Issue Date :
            <RangePicker
              style={{ width: "100%" }}
              picker={type}
              onChange={(value) => {
                if (value) {
                  if (type === "date") {
                    start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                    end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                  } else if (type === "month") {
                    start.current =
                      value[0].startOf("month").format("YYYY-MM-DD") +
                      "T00:00:00";
                    end.current =
                      value[1].endOf("month").format("YYYY-MM-DD") +
                      "T23:59:59";
                  } else if (type === "year") {
                    start.current =
                      value[0].startOf("year").format("YYYY-MM-DD") +
                      "T00:00:00";
                    end.current =
                      value[1].endOf("year").format("YYYY-MM-DD") + "T23:59:59";
                  }

                  setreload(!reload);
                }
              }}
            />
            Outlet:
            <Select
              style={{ width: 200 }}
              placeholder="Please select an outlet"
              onChange={(e) => {
                location.current = e;
                setreload(!reload);
              }}
            >
              <Option value="">All</Option>
              {outletlist.map((outlet) => (
                <Option key={outlet.id} value={outlet.id}>
                  {outlet.name}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              style={{ width: "100%", marginRight: "4px" }}
              onClick={onSearchClick}
            >
              Search
            </Button>
          </Space>
        </Row>
        <Divider />
        {rendertable()}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  Auth: state.auth,
});

export default connect(mapStateToProps, {
  getSalesReport,
  getSalesReportP,
  getAllOutlet,
})(Index);
